import React, { useRef } from "react";
import CustomButton from "../common/CustomBtn";
import equipIcon from "../../assets/equipment-icon.png";
import sparePartIcon from "../../assets/spare-part-icon.png";
import safeCoasting from "../../assets/safe-coating-icon.png";
import smallArchIcon from "../../assets/small-architecture-icon.png";
import { useNavigate } from "react-router-dom";
import { motion, useInView } from "framer-motion";
import { useTranslation } from "react-i18next";

const Offers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ref = useRef(null);
  const inView = useInView(ref, { margin: "-100px" });

  const offerData = [
    {
      id: 1,
      title: t("offersTranslate.equipment"),
      desc: t("offersTranslate.equipment_desc"),
      img: equipIcon,
      path: "/el-parduotuve/zaidimu-aiksteles",
    },
    {
      id: 2,
      title: t("offersTranslate.safe_coatings"),
      desc: t("offersTranslate.safe_coatings_desc"),
      img: safeCoasting,
      path: "/el-parduotuve/saugios-dangos",
    },
    {
      id: 3,
      title: t("offersTranslate.small_architecture"),
      desc: t("offersTranslate.small_architecture_desc"),
      img: smallArchIcon,
      path: "/el-parduotuve/mazoji-architektura",
    },
    {
      id: 4,
      title: t("offersTranslate.spare_parts"),
      desc: t("offersTranslate.spare_parts_desc"),
      img: sparePartIcon,
      path: "/el-parduotuve/atsargines-dalys",
    },
  ];

  return (
    <section className="relative w-full h-full px-[5%] bg-[#F2F6F7]">
      <div
        ref={ref}
        className="grid grid-cols-1 gap-8 py-20 md:py-24 maxContainer sm:gap-6 md:gap-12 sm:grid-cols-2 md:grid-cols-4"
      >
        {offerData.map((item, index) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{
              type: "tween",
              duration: 0.8,
              delay: index * 0.3,
            }}
            whileHover={{ scale: 1.05, transition: { duration: 0.3 } }}
            className="relative max-w-[429px] w-full flex flex-col justify-between items-center"
          >
            <div className="relative mb-4">
              <img src={item.img} alt={item.title} width={80} height={80} />
            </div>
            <div className="flex flex-col justify-center text-center">
              <h2 className="mb-4 leading-tight text-[28px] ss:text-sm font-medium">
                {item.title}
              </h2>
              <p className="text-[14px] mb-4">{item.desc}</p>
              <div>
                <CustomButton
                  variant="outlined"
                  color="primary"
                  onClick={() => navigate(item.path)}
                >
                  {t("offersTranslate.button_text")}
                </CustomButton>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Offers;
